import { ThemeConfig } from "antd5";
import { antdComponentTokens, antdTokens } from "styles/generated/antdTheme";

import * as colors from "../../lib/themes/colors";

export const DefaultTheme: ThemeConfig = {
  token: {
    fontFamily: "InterVariable, sans-serif",
    // Colour and radius tokens map onto the semantic system, generated from
    // the canonical token source (design-tokens/ at the repo root).
    ...antdTokens,
    // Overlay values with no semantic token yet — kept as-is.
    colorBgMask: "rgba(45, 59, 84, 0.5)",
    colorBgSpotlight: "rgba(45, 59, 84, 1)",
    fontSizeHeading2: 32,
    fontSizeHeading1: 40,
    lineHeight: 1.57,
    lineHeightSM: 1.67,
    lineHeightLG: 1.57,
    lineHeightHeading1: 1.5,
    lineHeightHeading2: 1.5,
    lineHeightHeading3: 1.5,
    lineHeightHeading4: 1.5,
  },
  components: {
    Layout: {
      headerBg: "#fff",
      bodyBg: "#fff",
      siderBg: "#fff",
    },
    Button: {},
    Collapse: {
      colorBgContainer: "#fff",
      colorFillAlter: "#fff",
    },
    Tour: {
      colorBgContainer: colors.blue900,
      colorText: "#fff",
      colorIcon: "#fff",
      colorIconHover: "#fff",
    },
    Progress: {
      marginXS: 0,
    },
    Input: {
      colorIcon: colors.sysPrimaryDefault,
      colorIconHover: colors.sysPrimaryHover,
    },
    Menu: {
      ...antdComponentTokens.Menu,
      itemPaddingInline: 0,
    },
    Table: {
      colorFillAlter: colors.opacityDark2,
      borderRadiusLG: 4,
    },
    Radio: {
      ...antdComponentTokens.Radio,
    },
    Checkbox: {
      ...antdComponentTokens.Checkbox,
    },
  },
};
